module.exports = __webpack_public_path__ + "img/pr-14.98eb6666.png";